__turbopack_context__.v({
  "active": "mochi-progress-step-module-scss-module__zRZCuG__active",
  "breath": "mochi-progress-step-module-scss-module__zRZCuG__breath",
  "current": "mochi-progress-step-module-scss-module__zRZCuG__current",
  "progress": "mochi-progress-step-module-scss-module__zRZCuG__progress",
});
